import React from "react";
import { Link, SimpleGrid } from "@chakra-ui/react";
import { IconFeatureCard } from "components/cards";
import { type IconFeatureProps } from "components/icon-feature";
import { PrivacyDataSharingIcon } from "./privacy-data-sharing-icon";
import { PrivacyResidencyLawsIcon } from "./privacy-residency-laws-icon";
import { PrivacyDataStorageIcon } from "./privacy-data-storage-icon";

export function PrivacyComplianceFeatures() {
  const privacyFeatures: IconFeatureProps[] = [
    {
      icon: PrivacyDataSharingIcon,
      title: "Easily honor opt-outs & data sharing preferences",
      description:
        "With a few filters and field mappings, you can honor data sharing and privacy preferences from your source of truth in the warehouse, ensuring full and accurate compliance.",
    },
    {
      icon: PrivacyResidencyLawsIcon,
      title: "Comply with data residency laws",
      description: (
        <>
          Maintain compliance with GDPR and other data residency regulations by ensuring{" "}
          <Link variant="article" _hover={{ color: "mint" }} href="/docs/security/storage">
            data storage
          </Link>
          , processing, and logging are done in the{" "}
          <Link variant="article" _hover={{ color: "mint" }} href="/docs/security/regions">
            appropriate region
          </Link>
          .
        </>
      ),
    },
    {
      icon: PrivacyDataStorageIcon,
      title: "No third-party data storage required",
      description:
        "You never have to store regulated third-party data in your infrastructure, and Hightouch never has to store your first-party data on our premises.",
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap="5" my="20" width={{ md: "100%" }}>
      {privacyFeatures.map((feature) => (
        <IconFeatureCard key={feature.title} variant="outline" feature={{ mobileJustify: "start", ...feature }} />
      ))}
    </SimpleGrid>
  );
}
